export const SET_COOKIES_GROUPS_INITIAL = 'COOKIE_SETTINGS:SET_COOKIES_GROUPS_INITIAL';

export const setCookiesGroupsInitial = (groupsData) => ({
    type: SET_COOKIES_GROUPS_INITIAL,
    payload: groupsData
});
